import {
    AvailableRegionName,
    UserVisibilityOptions,
    GroupVisibilityOptiions,
} from "../../../types/EditModal/types";

export const regionMap = new Map<AvailableRegionName, number>([
    ["Москва и МО", 77],
    ["Санкт-Петербург и ЛО", 78],
]);

export const getCookie = (name: string) => {
    const v = `; ${document.cookie}`.split(`; ${name}=`);
    return v.length === 2 ? v.pop()?.split(";").shift() : null;
};

export const transformUserVisibilityLocale = (val: UserVisibilityOptions) => {
    switch (val) {
        case "Все": {
            return "all";
        }
        case "Никто": {
            return "nobody";
        }
        case "Только пользователи": {
            return "users_only";
        }
        default:
            return undefined;
    }
};

export const transformGroupVisibilityLocale = (
    val: GroupVisibilityOptiions,
) => {
    switch (val) {
        case "Все": {
            return "all";
        }
        case "Никто": {
            return "nobody";
        }
        case "Только участники": {
            return "members_only";
        }
        case "Только пользователи": {
            return "users_only";
        }
        default:
            return undefined;
    }
};
